module.exports = __webpack_public_path__ + "static/media/tick-circle.e237338a.svg";